import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { PlayIcon } from "./PlayIcon"
import { isMediaFileVideo, getMediaUrl } from "utils/media-upload"

export const MediaPreview = ({ media, className, wrapperClassName, onClick, playIconSize = "md", lazyLoad = true, objectFit = "cover" }) => {
  const isVideo = isMediaFileVideo(media)
  const objectFitClass = objectFit === "contain" ? "object-fit-contain" : "object-cover"

  const Media = () => {
    // For videos, we want the thumbnail image, not the video URL
    const src = getMediaUrl(media, isVideo)

    const handleKeyDown = (e) => {
      if (onClick && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault()
        onClick()
      }
    }

    if (lazyLoad) {
      const lazyImage = (
        <LazyLoadImage
          src={src}
          alt=""
          className={classNames(objectFitClass, "w-full h-full rounded", className)}
          wrapperClassName={classNames("w-full h-full", wrapperClassName)}
          effect="blur"
          placeholderSrc={media?.placeholder_url}
        />
      )

      if (onClick) {
        return (
          <div
            role="button"
            tabIndex={0}
            className={classNames("w-full h-full cursor-pointer", wrapperClassName)}
            onClick={() => onClick()}
            onKeyDown={handleKeyDown}
          >
            {lazyImage}
          </div>
        )
      }

      return lazyImage
    }

    const regularImage = (
      <img
        src={src}
        alt=""
        className={classNames(objectFitClass, "w-full h-full rounded", className)}
      />
    )

    if (onClick) {
      return (
        <div
          role="button"
          tabIndex={0}
          className={classNames("w-full h-full cursor-pointer", wrapperClassName)}
          onClick={() => onClick()}
          onKeyDown={handleKeyDown}
        >
          {regularImage}
        </div>
      )
    }

    return <div className={classNames("w-full h-full", wrapperClassName)}>{regularImage}</div>
  }

  if (isVideo) {
    return (
      <div className="relative w-full h-full rounded overflow-hidden">
        <Media />
        <PlayIcon
          size={playIconSize}
          onClick={(e) => {
            e.stopPropagation()
            onClick?.()
          }}
        />
      </div>
    )
  }

  return <Media />
}

MediaPreview.propTypes = {
  media: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    thumbnail_url: PropTypes.string,
    placeholder_url: PropTypes.string,
    type: PropTypes.oneOf(["image", "video"])
  }).isRequired,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  onClick: PropTypes.func,
  playIconSize: PropTypes.string,
  lazyLoad: PropTypes.bool,
  objectFit: PropTypes.oneOf(["cover", "contain"])
}
